export class Route {
  static ACTIVITIES_CONFIG = `/${window.locale}/activities_configs.json`;
  static ACTIVITIES_CONFIG_DECODES_FOR_SELECT = `/${window.locale}/activities_configs/decodes_for_select`;
  static ACTIVITIES_CONFIG_GET_SUB_ACTIVITIES = `/${window.locale}/activities_configs/get_sub_activities_configs`;
  static BUSINESS_UNIT = `/${window.locale}/business_units`;
  static CDN_ACARE = 'https://cdn-acare.e-personam.com';
  static CDN_ACARE_JS_MD5 = 'https://cdn-acare.e-personam.com/ext/js-md5/v0.7.3/js-md5.min.js';
  static CDN_ACARE_JS_BARCODE = 'https://cdn-acare.e-personam.com/ext/js-barcode/v3.11.3/JsBarcode.all.min.js';
  static CONSENT_TEMPLATES = `/${window.locale}/business_units/__BU_ID__/consent_templates`;
  static GPDS_CONSENTS = `/${window.locale}/guest_period_data_sets/__GPDS_ID__/consents`;
  static USERS_BU_CONSENTS = `/${window.locale}/users_business_units/__USERS_BU_ID__/consents`;
  static DECODES_CONFIG = `/${window.locale}/decodes_configs`;
  static DECODES_CONFIG_GET_VALUES = `/${window.locale}/decodes_configs/get_values.json`;
  static DECODES_CONFIG_AUTOCOMPLETE = `/${window.locale}/decodes_configs/autocomplete`;
  static DOCUMENT = `/${window.locale}/documents`;
  static DOCUMENT_TOGGLE_PERSONAL = `/${window.locale}/documents/toggle_personale`;
  static DOCUMENT_TOGGLE_PWF = `/${window.locale}/documents/toggle_pwf`;
  static DOCUMENT_TOGGLE_RESERVED = `/${window.locale}/documents/toggle_riservato`;
  static DOCUMENT_TOGGLE_SAN = `/${window.locale}/documents/toggle_san`;
  static DOCUMENTS_BY_TAG = `/${window.locale}/documents/tag/__TAG_ID__`;
  static DOMESTIC = `/${window.locale}/domestic`;
  static DOMESTIC_CALENDAR = `/${window.locale}/domestic/calendar`;
  static DOMESTIC_CHECK_IF_USER_IS_FREE = `/${window.locale}/user_bu_absences/check_if_user_is_free`;
  static DOMESTIC_CREATE_ACTIVITY_REGISTRATION = `/${window.locale}/domestic/create_activity_registration.json`;
  static DOMESTIC_EDIT_ACTIVITY_REGISTRATION = `/${window.locale}/domestic/guest_activities/__TAG_ID__`;
  static DOMESTIC_MAP = `/${window.locale}//domestic/agenda_map.html`;
  static DOMESTIC_MENU = `/${window.locale}/domestic/menu_domiciliare`;
  static DOMESTIC_RESIDUAL_CALCULATION_GDPSE = `/${window.locale}/domestic/residual_calculation_gpdse.json`;
  static DRUGS_CONFIG = `/${window.locale}/drugs_configs`;
  static EDIT_ACTIVITY_REGISTRATION_URL = `/${window.locale}/domestic/guest_activities/__TAG_ID__/edit`;
  static FLUX_EXPORTS = `/${window.locale}/flux_exports`;
  static GUEST_DRUG_SWAP = `/${window.locale}/guest_drugs/swap`;
  static GUEST_PERIOD_DATA_SET = `/${window.locale}/guest_period_data_sets`;
  static GUESTS = `/${window.locale}/guests`;
  static JOB_STATUS = `/asynch/job_status`;
  static MEETINGS = `/${window.locale}/meetings`;
  static PARAMETERS_CONFIG = `/${window.locale}/parameters_configs`;
  static REPORT = `/${window.locale}/reports`;
  static REPORT_TEMPLATE = `/${window.locale}/report_templates`;
  static GENERATE_REPORT = `/${window.locale}/reports/generate_report.json`;
  static GENERATE_EXCEL = `/${window.locale}/reports/generate_excel.json`;
  static SHOW_ACTIVITY_REGISTRATION_URL = `/${window.locale}/domestic/guest_activities/__TAG_ID__/show`;
  static SIAD_IMPORTS = `/${window.locale}/siad_imports`;
  static SIAD_CONVERTERS = `/${window.locale}/siad_converters`;
  static SIAD4 = `/${window.locale}/siad4s`;
  static VISIT_RELATIVES_TIME_SLOT_CONFIG = `/${window.locale}/visit_relatives_time_slots_configs`;
  static USER = `/${window.locale}/users`;
  static USER_STATUS = `/${window.locale}/users_statuses`;
  static USERS_BUSINESS_UNIT = `/${window.locale}/users_business_units`;
  static GUEST_BUSINESS_UNIT_AUTOCOMPLETE_GUESTS_FULL_NAME = `/${window.locale}/guest_business_units/autocomplete_guests_full_name`;
  static GUEST_AUTOCOMPLETE_GUEST_FIRSTNAME = `/${window.locale}/guests/autocomplete_guest_firstname.json`;
  static USERS_REFRESH_SESSION = `/${window.locale}/users/refresh_session`;
  static USERS_SIGN_OUT = '/users/sign_out.json';
  static CDN_ACARE_CBOR = 'https://cdn-acare.e-personam.com/adv-cbor/v1.0.0/cbor.min.js';
  static CDN_ACARE_COSETOJWK = 'https://cdn-acare.e-personam.com/adv-cose-to-jwk/v1.0.0/coseToJwk.min.js';
  static CDN_ACARE_WEBAUTHN = 'https://cdn-acare.e-personam.com/adv-webauthn/v1.1.0/webauthn.min.js';
  static REQUEST_OTP = `/${window.locale}/digital_signature/request_otp.json`;
}
